let split = null;
let triggers = [];

export function textFill() {
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof SplitText === 'undefined') return;

	triggers.forEach(t => t.kill());
	if (split) split.revert();

	split = new SplitText(".text-fill > p", { type: "lines" });

	triggers = split.lines.map(line =>
		ScrollTrigger.create({
		trigger: line,
		start: "top center",
		end: "bottom center",
		scrub: true,
		animation: gsap.fromTo(
			line,
			{ backgroundPositionX: "100%" },
			{ backgroundPositionX: "0%", ease: "none", overwrite: "auto" }
		)
		})
	);
}